import { useQuery, useQueryClient } from "@tanstack/react-query";
import { Recipe } from "../../models/Recipe";
import { getRecipes } from "../../repositories/RecipeRepository";

export const useRecipesQuery = (
  onlyEnabled: boolean = false,
  onlyCurrent: boolean = false,
  onError?: (error: Error) => void,
) => {
  return useQuery<Recipe[], Error>({
    queryKey: ["recipes", onlyEnabled, onlyCurrent],
    queryFn: async ({ signal }) => {
      const resp = await getRecipes(onlyEnabled, onlyCurrent, signal);
      if (!resp.ok) {
        throw new Error(resp.message || "Failed to load recipes");
      }
      return resp.data?.tables?.[0]?.rows || [];
    },
    onError,
  });
};

export const useInvalidateRecipes = () => {
  const queryClient = useQueryClient();
  return () => queryClient.invalidateQueries({ queryKey: ["recipes"] });
};
